/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFunction: {
  name: 'function';
  data: string;
} = {
  name: 'function',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5a1 1 0 0 0-1 1v4h3a1 1 0 1 1 0 2h-3v6a3 3 0 1 1-6 0 1 1 0 1 1 2 0 1 1 0 1 0 2 0v-6H6a1 1 0 1 1 0-2h2V6a3 3 0 0 1 6 0 1 1 0 1 1-2 0 1 1 0 0 0-1-1Zm8.707 11.707a1 1 0 0 0-1.414-1.414L17 16.586l-1.293-1.293a1 1 0 0 0-1.414 1.414L15.586 18l-1.293 1.293a1 1 0 0 0 1.414 1.414L17 19.414l1.293 1.293a1 1 0 0 0 1.414-1.414L18.414 18l1.293-1.293Z" fill="currentColor"/></svg>`,
};
